import React, { ReactNode } from 'react'
import './typography.sass'

const UppercaseLabel: React.FC<{ children?: ReactNode | string }> = ({ children }) => {
    return <span className="typography-uppercase-label-text normal-text">{children}</span>
}

export default UppercaseLabel
